var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header-top"},[_c('div',{staticClass:"header-top__logo"},[(_vm.visibleLogo)?_c('LogoIcon'):_vm._e()],1),_c('div',{staticClass:"header-top__city"},[_c('CitySelector')],1)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }